// extracted by mini-css-extract-plugin
export default {"hcol":"dcc_packageTab-hcol","col":"dcc_packageTab-col","standardContentItem":"dcc_packageTab-standardContentItem"};